import { FC, useContext } from 'react'
import styles from './search-button.module.scss'
import Button from '../Button'
import SearchIcon from '@/components/icons/SearchIcon'
import classNames from '@/utils/helpers/class-names.helper'
import MainModalsContext from '@/contexts/main-modals.context'

type SearchButtonProps = {
  className?: string
}

const SearchButton: FC<SearchButtonProps> = ({ className }) => {
  const { searchPopup } = useContext(MainModalsContext)

  return (
    <Button
      onClick={() => searchPopup.setActive(true)}
      aria-label="Поиск по сайту"
      className={classNames(styles.button, className)}
      iconClassName={styles.icon}
      icon={<SearchIcon />}
    />
  )
}

export default SearchButton
